export default "__VITE_ASSET__f52fbcfc__"